import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { LayoutService } from '@fgb/portal-component-library/src/lib/shared/services';

@Component({
  selector: 'fgb-account-layout',
  templateUrl: './account-layout.component.html',
  styleUrls: ['./account-layout.component.scss'],
})
export class AccountLayoutComponent implements OnInit, OnDestroy {
  @Input() titleKey: string;
  @Input() titleDefault: string;
  @Input() isProfilePage = false;

  constructor(private layoutService: LayoutService) {}

  ngOnInit() {
    this.layoutService.hideMobileNavbar();
  }

  ngOnDestroy() {
    this.layoutService.showMobileNavbar();
  }
}
